/**
 * Redirige el navegador a Webpay (PAG-01).
 *
 * No es un `location.href = url`: Transbank exige que el `token` viaje como
 * POST, no como parametro de la URL (asi lo documenta Webpay Plus). Se arma
 * un formulario invisible y se lo manda solo — es la unica forma de hacer un
 * POST entre paginas sin JavaScript de por medio en el otro extremo.
 */
export function redirigirAWebpay(url: string, token: string): void {
  const formulario = document.createElement('form');
  formulario.method = 'POST';
  formulario.action = url;

  const campoToken = document.createElement('input');
  campoToken.type = 'hidden';
  campoToken.name = 'token_ws';
  campoToken.value = token;

  formulario.appendChild(campoToken);
  document.body.appendChild(formulario);
  formulario.submit();
}
